import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./ngohome2.css";
import Header from "./components/ngoheader";
import Footer from "./components/ngofooter";

// 👉 replace these later with your actual images

import doghero from "./images/doghero.jpg";

export default function NGOHome() {
  return (
    <>

      {/* ================= HEADER ================= */}
      <Header/>




      {/* ================= HERO ================= */}
      <section className="hero-section">
        <div className="container">
          <div className="row align-items-center">

            <div className="col-lg-6 hero-text">
              <h1>Give Stray Dogs a Better Life</h1>
              <p>
                Your small donation can provide food, shelter, and medical care
                to stray dogs in need.
              </p>

              <div className="hero-buttons">
                <button className="btn-primary-donate">Donate ₹99</button>
                <button className="btn-secondary-donate">Donate ₹999</button>
              </div>
            </div>

            <div className="col-lg-6">
              <img src={doghero} alt="dog" className="hero-img" />
            </div>

          </div>
        </div>
      </section>


      {/* ================= DONATION ================= */}
      <section className="donation-section">
        <div className="container">

          <h2 className="section-title">Support a Dog Today</h2>

          <div className="row g-4">

            <div className="col-lg-4 col-md-6">
              <div className="donation-card">
                <h3>Feed a Dog</h3>
                <h2>₹99</h2>
                <p>Provide one nutritious meal to a stray dog.</p>
                <button className="card-btn">Donate</button>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="donation-card">
                <h3>Medical Help</h3>
                <h2>₹999</h2>
                <p>Support treatment for injured dogs.</p>
                <button className="card-btn">Donate</button>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="donation-card">
                <h3>Custom Amount</h3>
                <input
                  type="number"
                  placeholder="Enter amount"
                  className="custom-input"
                />
                <button className="card-btn">Donate</button>
              </div>
            </div>

          </div>
        </div>
      </section>


      {/* ================= IMPACT ================= */}
      <section className="impact-section">
        <div className="container text-center">

          <div className="row">

            <div className="col-md-3 col-6 impact-box">
              <h2>1200+</h2>
              <p>Dogs Fed</p>
            </div>

            <div className="col-md-3 col-6 impact-box">
              <h2>300+</h2>
              <p>Treatments</p>
            </div>

            <div className="col-md-3 col-6 impact-box">
              <h2>80+</h2>
              <p>Rescues</p>
            </div>

            <div className="col-md-3 col-6 impact-box">
              <h2>500+</h2>
              <p>Supporters</p>
            </div>

          </div>
        </div>
      </section>


      {/* ================= MISSION ================= */}
      <section className="mission-section">
        <div className="container">
          <div className="row align-items-center">

            <div className="col-lg-6">
              <img
                src="https://images.unsplash.com/photo-1583511655857-d19b40a7a54e"
                alt="mission"
                className="mission-img"
              />
            </div>

            <div className="col-lg-6 mission-text">
              <h2>Our Mission</h2>
              <p>
                ORRBIIT Relief works to protect and care for stray dogs by
                providing food, treatment, and rescue services.
              </p>

              <ul>
                <li>Daily Feeding</li>
                <li>Emergency Medical Care</li>
                <li>Rescue Operations</li>
                <li>Community Awareness</li>
              </ul>
            </div>

          </div>
        </div>
      </section>


      <Footer/>

    </>
  );
}